import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { pagesPATH } from 'src/app/models_new/config/pages';
import { PublicApiService } from 'src/app/services/api/public-api.service';

@Component({
  selector: 'app-subscription-block',
  templateUrl: './subscription-block.component.html',
  styleUrls: ['./subscription-block.component.scss'],
})
export class SubscriptionBlockComponent {
  error: Error;

  constructor(private router: Router, public publicApi: PublicApiService) {
    this.error = new Error('Subscription block error');
  }

  navigateToHome() {
    this.router.navigate([pagesPATH.USER, pagesPATH.LANDING_PAGE]);
  }
}
